<template>
  <button @click.prevent="action" @mouseenter="$hover" :class="[$style.link, $style[direction], labeled ? $style.bottom : false]">
    <svg :class="$style.arrow" viewBox="0 0 40 9" xmlns="http://www.w3.org/2000/svg" ref="icon">
      <path :class="$style.arrowTriangle" d="M2.1 4.7l3.2-3.2c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0L1 4.3c-.1.2-.1.3-.1.4 0 .1 0 .3.1.4l3.6 3.6c.1.1.3.1.4.1.1 0 .3 0 .4-.1.2-.2.2-.5 0-.7L2.1 4.7z" fill="#3C3C40"/>
      <path :class="$style.arrowLine" d="M1.4 4.7h38.1" stroke="#3C3C40" fill="none"/>
    </svg>
    <svg :class="$style.circle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.49 30.49"><circle cx="15.25" cy="15.25" r="14.75" fill="none" stroke="#3C3C40" stroke-width="0.6"/></svg>
    <svg :class="$style.circleHover" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.49 30.49"><circle cx="15.25" cy="15.25" r="14.75" fill="none" stroke="#0072CE" stroke-width="0.6"/></svg>
    <span :class="[$style.caption, labeled ? $style.visible : '' ]"><span><slot /></span></span>
  </button>
</template>

<script>
export default {
  props: ['id', 'direction', 'action', 'labeled']
}
</script>

<style module lang="scss">
@import "~sass-mq/mq";

.link {
  position: relative;
  background: transparent;
  border: 0;
  outline: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;

  &.left {
    left: 0;

    span {
      left: 150%;
    }

    .arrow {
      transform: translate(20px, 0);
      transform-origin: 0% 50%;

      .arrowLine {
        transform: scaleX(0.4);
        transform-origin: 0% 50%;
      }
    }

    .circle, .circleHover {
    }
  }

  &.right {
    right: 0;

    .caption {
      right: 150%;
    }

    .arrow {
      transform: scaleX(-1) translate(60px, 0);
      transform-origin: 100% 50%;

      .arrowLine {
        transform: scaleX(0.4);
        transform-origin: 0% 50%;
      }
    }

    .circle, .circleHover {
    }
  }

  &.bottom {
    @include mq($until: sm) {
      height: 100%;
      position: relative;
      svg {
        display: none;
      }

      &.right {
        right: 0px;
        margin: 0 auto;

        .caption {
          right: 0px;
        }
      }

      span {
        position: relative;
      }

      &.left {
        left: 0px;
        margin: 0 auto;

        span {
          left: 0;
        }
      }

      .caption.visible {
        margin: 0;

        span {
          margin: 0;
        }
      }
    }
  }

  :global(.no-touchevents) &:hover {
    &.left {
      .arrow {
        // transform: translate(-5%, 0);
        .arrowTriangle {
          fill: $color-white;
        }
        .arrowLine {
          stroke: $color-white;
          transform: scaleX(1);
        }
      }
      .circleHover {
        circle {
          // stroke-dasharray: 0;
          stroke-dashoffset: 0;
        }
      }
    }

    &.right {
      .arrow {
        // transform: scaleX(-1) translate(-5%, 0);
        .arrowTriangle {
          fill: $color-white;
        }
        .arrowLine {
          stroke: $color-white;
          transform: scaleX(1);
        }
      }
      .circleHover {
        circle {
          // stroke-dasharray: 0;
          stroke-dashoffset: 0;
        }
      }
    }

    .caption {
      opacity: 1;
    }
  }

  &:focus {
    outline: none;
  }

  .caption {
    position: absolute;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    margin: 0 10px;

    opacity: 0;
    transition: all 0.3s ease-out;
    font-weight: 600;
    letter-spacing: 2.5px;
    text-transform: uppercase;
    color: $color-blue;
    font-size: font-size(s);

    &.visible {
      opacity: 1;

      span {
        margin: 0 10px;
      }
    }
  }

  .arrow {
    width: 50px;
    height: 60px;
    transition: all 0.3s ease-out;

    * {
      transition: all 0.3s ease-out;
    }
  }

  .circle {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 60px;
    height: 60px;
    z-index: -2;
    transition: all 0.5s ease-out;

    circle {
      stroke-dasharray: 46.25px;
      stroke-dashoffset: 0px;
    }
  }

  .circleHover {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 60px;
    height: 60px;
    z-index: -1;
    transition: all 0.5s ease-out;

    circle {
      transition: all 0.4s ease-out;
      stroke-dasharray: 92.5px;
      stroke-dashoffset: 92.5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ArrowButton.vue